"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asOptions = void 0;
exports.default = textClasses;
exports.emphasisOptions = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _feedbackExpressions = _interopRequireDefault(require("@ux/intents/lib/feedback-expressions"));
// Possible options for as prop
const asOptions = exports.asOptions = ['title', 'heading', 'paragraph', 'action', 'input', 'label', 'caption'];
const emphasisOptions = exports.emphasisOptions = Object.values(_feedbackExpressions.default).map(v => v.toLowerCase());
const UX_TEXT_CLASSNAME = 'ux-text';

/**
 * Creates a collection of classes for text styles
 *
 * @param {Object} props - A props configuration object
 * @param {String} [props.as] - A category of text
 * @param {String} [props.className] - A class name to include
 * @param {String} [props.emphasis] - Includes styles to represent feedback
 * @param {Number} [props.size] - A number representing the font size
 * @returns {String} A collection of class names
 */
function textClasses(props) {
  const {
    as,
    className,
    emphasis,
    size
  } = props || {};
  return (0, _classnames.default)(UX_TEXT_CLASSNAME, className, {
    [`${UX_TEXT_CLASSNAME}-size${size}`]: typeof size === 'number' && size >= -2 && size < 6,
    [`${UX_TEXT_CLASSNAME}-${as}`]: as && asOptions.includes(as),
    [`${UX_TEXT_CLASSNAME}-feedback-${emphasis}`]: emphasis && emphasisOptions.includes(emphasis)
  });
}